<template>
    <div>
      <div class="card" style="padding: 5px 10px 5px; border-radius: 10px">
        <div class="card-header">
          <div class="row">
            <div class="col-md-10">
              <strong style="font-size:20px">Información por entidades</strong><br />
              <span style="color: darkgrey"
                >Información de las ganancias y servicios no completados por entidad</span
              > <br>
              <span style="color:darkgray">Resumen: <span style="color:green;"> <i class="fa fa-arrow-up" style="color: green"></i> {{ resumenEntidad }}</span> || <span style="color:red"><i class="fa fa-arrow-down" style="color: red"></i> {{ resumenCanceladasEntidad }}</span></span>
            </div>
            <!-- <div class="col-md-2">
              <button
                class="btn pull-right"
                style="border-radius: 8px"
                @click="abrirModal()"
              >
                <i class="fa fa-arrow-right"></i>
              </button>
            </div> -->
          </div>
        </div>
        <hr>
        <div class="card-content" style="max-height: 400px; overflow: scroll; overflow-x: hidden;">
          <div class="row">
            <div
              class="col-md-12"
              v-for="entidad in informacionEntidad"
              :key="entidad.nombre"
            >
              <div class="card" style="border:1px darkgray solid;">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-4">
                      <strong>{{ entidad.nombre != 'N/A' ? entidad.nombre : 'Particulares' }}</strong> <br />
                      <small style="color: grey">ENTIDAD</small>
                    </div>
                    <div class="col-md-4">
                      <i class="fa fa-arrow-up" style="color: green"></i>
                      <strong> {{ entidad.realizadas  }}</strong> <br />
                      <small style="color: grey">TOTAL EN SERVICIOS REALIZADOS</small>
                    </div>
                    <div class="col-md-4">
                      <i class="fa fa-arrow-down" style="color: red"></i>
                      <strong> {{ entidad.canceladas  }}</strong> <br />
                      <small style="color: grey">SERVICIOS NO COMPLETADOS</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    <script>
  import nomicard from "src/components/aDashboard/nomina/cardnomina.vue";
  import axiosInstance from "src/global-services/axiosInstance";
  import formatearPesosColombianos from "../../../global-services/formatear-pesos";
  export default {
    data() {
      return {
        informacionEntidad: [],
        resumenEntidad: 0,
        resumenCanceladasEntidad: 0
      };
    },
    methods: {
      getInformationEntidades: async function (fechaInicial, fechaFinal) {
        try {
          const BASE_URL = `api/informacion-dashboard-entidad/${fechaInicial}/${fechaFinal}`;
          const response = await axiosInstance.get(BASE_URL);
          if (response.data.status == true) {
            const data = response.data.data;
            let resumen = 0;
            let resumenCanceladas = 0;
            let dataFormated = data.map((element) => {
              resumen = resumen + parseInt(element.Realizadas);
              resumenCanceladas = resumenCanceladas + parseInt(element.Canceladas);
              return {
                nombre: element.nombre,
                realizadas: formatearPesosColombianos(element.Realizadas),
                canceladas: formatearPesosColombianos(element.Canceladas),
              };
            });
            this.resumenCanceladasEntidad = formatearPesosColombianos(resumenCanceladas);
            this.resumenEntidad = formatearPesosColombianos(resumen);
            this.informacionEntidad = dataFormated;
          }
        } catch (error) {
        } finally {
        }
      },
    },
    components: {
      nomicard,
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionEntidad.vue